import React from 'react';
import FAQ from './FAQ';

const webDevFAQ = [
  {
    question: 'Do you offer custom software development?',
    answer:
      'Yes, we specialize in custom software development tailored to your needs.',
  },
  {
    question:
      'How do you ensure the quality of your software product development services?',
    answer:
      'We follow industry best practices, including Agile methodologies and rigorous testing.',
  },
  {
    question:
      'Can you share some of your past projects? What is your experience in the software development field?',
    answer:
      'We have a diverse portfolio of successful projects. Contact us for case studies.',
  },
  {
    question:
      'Can you scale up resources, if required, in the middle of the development process?',
    answer: 'Yes, we offer flexible scaling options to meet project demands.',
  },
  {
    question: 'How much does it cost to develop custom software?',
    answer:
      'Cost depends on project scope, complexity, and features. Contact us for a quote.',
  },
  {
    question: 'Do you offer app maintenance and support services?',
    answer: 'Yes, we provide ongoing maintenance and support services.',
  },
  {
    question:
      'How does the Agile methodology differ from the traditional waterfall approach in software development?',
    answer:
      'Agile is iterative and flexible, while Waterfall is linear and structured.',
  },
  {
    question:
      'How do I choose the right IT outsourcing provider for my business needs?',
    answer:
      'Evaluate providers based on experience, expertise, and client reviews.',
  },
];

const WebDevFAQPage = () => {
  return <FAQ faqData={webDevFAQ} title='Software Development FAQs' />;
};

export default WebDevFAQPage;
